export const socketContext = 'socket';
